import React from "react";
import { useLocation } from "react-router-dom";
import BuyLabel from "components/Shipements/BuyLabel";

function SignageBuyLabel() {
  const location = useLocation();
  
  // Determine the base route based on current location
  const isSignageTeammember = location.pathname.includes('/signageteammember');
  const baseRoute = isSignageTeammember ? '/signageteammember' : '/signage';
  
  return <BuyLabel baseRoute={baseRoute} />;
}

export default SignageBuyLabel;
